<div class="background-global-footer">
    <div class="footer-component">
        <div class="background-footer">
            <div class="footer-inner">
                <div class="footer-main">
                    <div class="footer-brand">
                        <!-- El logo apilado sigue en móvil, donde comparte fila con las redes
                             y necesita ser cuadrado; en escritorio va el mismo horizontal de
                             la cabecera, que deja la marca a la altura de las columnas. -->
                        <img fallimg class="logo-footer logo-footer-wide d-none d-md-block" src="assets/img/citylok_horizontal.svg" alt="Citylok logo">
                        <img fallimg class="logo-footer d-md-none" src="assets/img/citylok_vertical.svg" alt="Citylok logo">
                        <!-- En escritorio, bajo el logo; en móvil el logo comparte fila con
                             las redes, así que el reclamo baja al final del pie. -->
                        <p class="footer-tagline d-none d-md-block">{{ tagline }}</p>
                    </div>
                    <div class="social-media-footer d-flex align-items-center">
                        <!-- <i (click)="openSocialLink('twitter')" class="fa-brands fa-x-twitter fa-2x pointer-in"></i> -->
                        <i (click)="openSocialLink('instagram')" class="fa-brands fa-instagram fa-2x pointer-in" role="link" aria-label="Instagram"></i>
                        <i (click)="openSocialLink('tiktok')" class="fa-brands fa-tiktok fa-2x pointer-in" role="link" aria-label="TikTok"></i>
                        <!-- <i (click)="openSocialLink('youtube')" class="fa-brands fa-youtube fa-2x pointer-in"></i> -->
                        <i (click)="openSocialLink('facebook')" class="fa-brands fa-facebook-f fa-2x pointer-in" role="link" aria-label="Facebook"></i>
                    </div>
                    <div class="menu-footer">
                        <!-- Escritorio: una columna por grupo de navegación. Los legales no
                             son columna: van en la barra de abajo. -->
                        <div class="footer-columns d-none d-md-flex">
                            <div class="footer-column" *ngFor="let group of menuGroups">
                                <p class="title-menu-footer">{{ group.title }}</p>
                                <div class="options-menu">
                                    <a class="footer-link" *ngFor="let link of group.links" [routerLink]="link.route">{{ link.label }}</a>
                                </div>
                            </div>
                        </div>

                        <!-- Móvil: los mismos enlaces en línea, sin acordeón -->
                        <div class="footer-links d-md-none">
                            <div class="footer-links-row">
                                <ng-container *ngFor="let link of menuLinks; let last = last">
                                    <a class="footer-link" [routerLink]="link.route">{{ link.short || link.label }}</a>
                                    <span class="footer-links-sep" *ngIf="!last" aria-hidden="true">|</span>
                                </ng-container>
                            </div>
                            <div class="footer-links-row footer-links-legal">
                                <ng-container *ngFor="let link of legalLinks; let last = last">
                                    <a class="footer-link" [routerLink]="link.route">{{ link.short || link.label }}</a>
                                    <span class="footer-links-sep" *ngIf="!last" aria-hidden="true">|</span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Barra de cierre de escritorio: copyright a la izquierda y legales a
                     la derecha. En móvil los legales ya van en su fila. -->
                <div class="footer-bottom d-none d-md-flex">
                    <p class="footer-copy">© {{ year }} Citylok</p>
                    <div class="footer-legal">
                        <ng-container *ngFor="let link of legalLinks; let last = last">
                            <a class="footer-link footer-legal-link" [routerLink]="link.route">{{ link.label }}</a>
                            <span class="footer-links-sep" *ngIf="!last" aria-hidden="true">·</span>
                        </ng-container>
                    </div>
                </div>

                <!-- Solo en móvil, cerrando el pie centrado a lo ancho (el sitio que
                     ocupaba la franja del copyright). -->
                <p class="footer-tagline d-md-none">{{ tagline }}</p>
            </div>
        </div>
    </div>
</div>

<div class="section-cookies">
    <app-cookies></app-cookies>
</div>
